/// <reference path="../../services/command.service.js" />
/// <reference path="../../services/command-execution.service.js" />
/// <reference path="../../services/command-test.service.js" />
const mod = require('../../bahabot.module.js')


/**
 * @param {CommandService} CommandService
 */
function bbCommandsEditorController(CommandService, CommandTestService, $routeParams, $scope, $location) {
    this.svc = CommandService;
    this.params = $routeParams;
    this.location = $location;

    this.displayEventArgs = false;
    this.loading = false;
    this.error = null;

    this.deletedCmd = null;
    this.testLogs = null;

    this.cmd = {
        name: '',
        description: '',
        code: '',
        eventType: 'MessageEvent',
        schedule: null,
        priority: 0,
        enabled: true,
        onlineOnly: true,
    };

    this.schedule = {
        mode: 'on',
        repeatEveryMinutes: 1,
        dow: [true, true, true, true, true, true, true], // Monday to Sunday
        runAt: null
    };

    this.webhookAssociations = [];

    this.getPrimaryWebhookAssociation = () => {
        if (!this.webhookAssociations.length) return null;
        return this.webhookAssociations[0];
    }

    this.onEventTypeChange = () => {
        if (this.cmd.eventType !== 'UserCommandWakeupEvent') {
            this.cmd.schedule = null;
        }
    };

    this.onScheduleDowChange = () => {
        if (this.schedule.dow.every(v => !v)) {
            this.schedule.dow = this.schedule.dow.map(_ => true);
        }
    }

    this.onDeleteCommand = () => {
        this.deletedCmd = this.cmd;
    }

    this.onDeleteModalAction = (response) => {
        if (response === "confirm") {
            this.loading = true;
            CommandService.delete(this.params.id)
                .then(() => {
                    $location.path('/dashboard/commands');
                    this.deletedCmd = null;
                })
                .catch((e) => {
                    this.error = e.data.error;
                })
                .finally(() => {
                    this.loading = false;
                })
        } else {
            this.deletedCmd = null;
        }
    }

    this.generateWebhookAssociations = () => {
        if (this.cmd.eventType !== 'WebhookEvent') return
        this.cmd.webhookAssociations = this.webhookAssociations;
    }

    this.generateJSONSchedule = () => {
        if (this.cmd.eventType === 'UserCommandWakeupEvent') {
            const finalSchedule = {};

            const minutes = parseInt(this.schedule.repeatEveryMinutes, 10);
            if (!isNaN(minutes) && minutes > 0) {
                finalSchedule.repeatEveryMinutes = minutes;
            }

            const daysSelected = this.schedule.dow
                .map((v, i) => (v ? i : null))
                .filter(i => i !== null);

            if (daysSelected.length > 0) {
                finalSchedule.daysOfWeek = daysSelected;
            }

            if (this.schedule.runAt) {
                // Convert to RFC3339
                const dt = new Date(this.schedule.runAt);
                finalSchedule.runAt = dt.toISOString();
            }

            finalSchedule.mode = this.schedule.mode;

            this.cmd.schedule = JSON.stringify(finalSchedule);
        }
    }

    this.onSubmitCreate = () => {
        this.loading = true;
        CommandService.post(this.cmd).then(r => {
            $location.path('/dashboard/commands');
        }).catch(e => {
            this.error = e.data.error;
        }).finally(() => {
            this.loading = false;
        });
    }

    this.onSubmitUpdate = () => {
        this.loading = true;
        CommandService.patch(this.params.id, this.cmd).then(r => {
            $location.path('/dashboard/commands');
        }).catch(e => {
            this.error = e.data.error;
        }).finally(() => {
            this.loading = false;
        });
    }

    this.onSubmit = () => {
        this.error = null;
        this.generateJSONSchedule();
        this.generateWebhookAssociations();

        if (this.params?.id) {
            this.onSubmitUpdate();
        } else {
            this.onSubmitCreate();
        }
    };

    this.onTestCommand = () => {
        this.loading = true;
        CommandTestService.post({
            eventType: this.cmd.eventType,
            code: this.cmd.code
        }).then(r => {
            this.testLogs = r;
        }).catch(e => {
            console.log(e)
        }).finally(() => {
            this.loading = false;
        })
    }

    this.onTestModalAction = (response) => {
        this.testLogs = null;
    }

    $scope.$watch('$ctrl.schedule', (after, before) => {
        if (after.repeatEveryMinutes < 1 || angular.isUndefined(after.repeatEveryMinutes)) {
            this.schedule.repeatEveryMinutes = 1;
        }
    }, true);

    if (this.params?.id) {
        this.cmd.name = "...";
        this.loading = true;
        CommandService.get(this.params.id)
            .then((r) => {
                for (const key of Object.keys(this.cmd)) {
                    this.cmd[key] = r[key];
                }

                if (r.schedule) {
                    const schedule = JSON.parse(r.schedule);
                    schedule.dow = schedule.daysOfWeek;
                    delete schedule.daysOfWeek;
                    for (const key of Object.keys(this.schedule)) {
                        if (key === 'dow') {
                            const dow = [true, true, true, true, true, true, true];
                            for (idx in dow) {
                                if (schedule.dow.indexOf(+idx) < 0) dow[+idx] = false;
                            }
                            this.schedule.dow = dow;
                        } else {
                            this.schedule[key] = schedule[key];
                        }
                    }
                }

                if (r.webhookAssociations) {
                    this.webhookAssociations = r.webhookAssociations.map(wa => wa.receiverName);
                }
            })
            .catch((e) => {
                console.error(e);
                this.error = e.data.error;
            })
            .finally(() => {
                this.loading = false;
            })
    }
}

mod.component('bbCommandsEditor', {
    templateUrl: 'tpl/bb-commands-editor.component.html',
    bindings: {},
    controller: ["CommandService", "CommandTestService", "$routeParams", "$scope", "$location", bbCommandsEditorController]
});